import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { themeFromLSParser, ThemeStorageSetter } from '@utils';

import { EThemesEnum } from '@enum';

interface ThemeSliceState {
  theme: EThemesEnum;
}

const initialState: ThemeSliceState = {
  theme: themeFromLSParser(),
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme(state, { payload }: PayloadAction<EThemesEnum>) {
      state.theme = payload;
      ThemeStorageSetter(payload);
    },
  },
});

export default themeSlice.reducer;
